import { featureFlagClient } from '@trello/feature-flag-client';

import type { FeatureName } from './FeatureName';

const IS_PRELOADER_DISABLED_VALUE = '*';
type BlocklistValue = FeatureName | typeof IS_PRELOADER_DISABLED_VALUE;

/**
 * Feature preloading can be disabled either for a given feature or in general
 * via feature flag, as an additional lever in case of emergency.
 *
 * This hits the featureFlagClient directly instead of via hook because the
 * preloader only executes on mount anyway, so we want this value to be
 * instantly deterministic on page load, and we don't need to subscribe to it.
 */
export const isPreloaderDisabled = (featureName: FeatureName): boolean => {
  const blocklist = featureFlagClient.get<Array<BlocklistValue>>(
    'workflowers.feature-preloader-blocklist',
    [],
  );
  return (
    blocklist.includes(IS_PRELOADER_DISABLED_VALUE) ||
    blocklist.includes(featureName)
  );
};
